export const DEFAULT_ADMIN_ID = '1489045284';
export const DEFAULT_APP_ID = '1400520156';
export const SHOW_OWNER = true;
